var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tree-node", class: { "node-expanded": _vm.expanded } },
    [
      _c(
        "div",
        {
          staticClass: "node-content",
          class: { "node-selected": _vm.isSelected },
          on: { click: _vm.toggleExpanded }
        },
        [
          _c("div", {
            staticClass: "node-indent",
            style: { width: _vm.level * 12 + "px" }
          }),
          _vm.hasChildren
            ? _c(
                "div",
                { staticClass: "node-toggle" },
                [
                  _c("feather-icon", {
                    attrs: {
                      icon: _vm.expanded
                        ? "ChevronDownIcon"
                        : "ChevronRightIcon",
                      size: "14"
                    }
                  })
                ],
                1
              )
            : _c("div", { staticClass: "node-toggle-placeholder" }),
          _c(
            "div",
            { staticClass: "node-icon" },
            [
              _c("feather-icon", {
                class: {
                  "node-folder-icon":
                    _vm.item.type === "directory" || _vm.item.type === "drive",
                  "folder-open":
                    _vm.isSelected &&
                    (_vm.item.type === "directory" || _vm.item.type === "drive")
                },
                attrs: { icon: _vm.getNodeIcon(), size: "14" }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "node-label",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.nodeClick($event)
                }
              }
            },
            [
              _vm._v(" " + _vm._s(_vm.item.name) + " "),
              _vm.showItemCounts
                ? _c("span", { staticClass: "item-count" }, [
                    _vm._v(
                      " (" +
                        _vm._s(_vm.item.folder_count || 0) +
                        "/" +
                        _vm._s(_vm.item.file_count || 0) +
                        ") "
                    )
                  ])
                : _vm._e()
            ]
          )
        ]
      ),
      _vm.expanded && _vm.hasChildren
        ? _c("div", { staticClass: "node-children" }, [
            _vm.childrenLoading
              ? _c("div", { staticClass: "tree-loading-children" }, [_vm._m(0)])
              : _c(
                  "ul",
                  { staticClass: "child-list" },
                  _vm._l(_vm.childrenItems, function(child, index) {
                    return _c(
                      "li",
                      { key: "child-" + index, staticClass: "child-item" },
                      [
                        _c("tree-node", {
                          attrs: {
                            item: child,
                            level: _vm.level + 1,
                            "is-shared-context": _vm.isSharedContext,
                            "current-path": _vm.currentPath,
                            "file-explorer-service": _vm.fileExplorerService,
                            "drive-public-service": _vm.drivePublicService
                          },
                          on: { "node-click": _vm.handleChildNodeClick }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "spinner-border spinner-border-sm text-primary",
        attrs: { role: "status" }
      },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Carregando...")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }